// import gsap from 'gsap'
import { bp, callAfterResize, l, mm, onDOMAndFontsReady, preventOrphan, sel, selAll, stResizeObserver, wrapLastTwo } from './utils'
// import { SplitText } from 'gsap/SplitText'
// import SplitType from 'split-type'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(SplitText, ScrollTrigger)

export default function Estate() {
  //hero-v2.js loads as module
  console.log('estate.js loaded')
  // return
  const isDeskSafari = !!(window.safari && window.safari.pushNotification)
  const ifChromeBlur = !isDeskSafari ? { filter: 'blur(50px)' } : {}
  window.addEventListener('load', function () {
    document.fonts.load('1rem "DM Sans"').then(() => {
      const tW$ = sel('.h1--epic-w')
      // tW$.classList.add('blur-wrap')

      mm.add(bp.tabUp, () => {
        const intro$ = sel('.epic-intro-sec')
        const introBg$ = sel('.epic-intro__bg-w')
        const introDim$ = sel('.epic-intro__dim-top')
        const introBlend$ = sel('.epic-intro__dim')
        const introVidBg$ = sel('.epic-intro__vid-bg-w')
        const introH$ = intro$.querySelector('h2')
        const introHsT = SplitText.create(introH$, { type: 'chars, words' })
        const hero$ = sel('.hero.is--v2')
        const introShift = window.innerHeight - hero$.offsetHeight
        gsap.set(hero$, { marginBottom: `calc(${introShift}px - 100vh)` })
        gsap.set(introBlend$, { display: 'none' })
        // gsap.set(introVidBg$, { scale: 1.2 })
        const introTl = gsap
          .timeline({ defaults: { ease: 'none', duration: 2 } })
          // .from(introVidBg$, { autoAlpha: 0, ...(!isSafariMac ? { scale: 1.2 } : {}), duration: 7 }, 0)
          .from(introDim$, { autoAlpha: 0.7, duration: 7 }, 0)
          .from(introVidBg$, { scale: 1.2, duration: 7 }, 0)
          .from(intro$, { marginBottom: '-100vh' }, 5)
        ScrollTrigger.create({
          trigger: hero$,
          start: 'top top+=5',
          end: '300%',
          scrub: true,
          pin: intro$,
          // triggerActions: 'play none none reverse',
          animation: introTl,
        })
        ScrollTrigger.create({
          trigger: hero$,
          start: 'bottom 70%',
          toggleActions: 'play none none reverse',
          // markers: true,
          animation: gsap.from(introHsT.chars, {
            autoAlpha: 0,
            // filter: 'blur(50px)',
            ...ifChromeBlur,
            stagger: {
              each: 0.006,
            },
            duration: 0.8,
          }),
        })
      })
      // Props sec
      const prop$a = selAll('.epic-props__item')
      prop$a.forEach((prop$) => {
        // console.log(prop$)
        const p$a = prop$.querySelectorAll('.p--epic')
        p$a.forEach((p$) => {
          // gsap.set(p$, { marginBottom: '1.5rem' })
        })
        const pW$ = prop$.querySelector('.p-w--epic')
        // selAll('.p--epic').forEach((p$) => {
        //   wrapLastTwo(p$)
        //   console.log('p$', p$)
        // })
        const pWSt = SplitText.create(pW$, { type: 'words' })
        //
        const propTl = gsap.timeline({ defaults: { duration: 1, ease: 'none' } }).from(pWSt.words, {
          autoAlpha: 0.2,
          stagger: { amount: 5 },
        })
        ScrollTrigger.create({
          trigger: prop$,
          start: 'top bottom',
          // end: (p$a.length - 1) * 200 + '%',
          end: 'bottom 75%',
          scrub: true,
          animation: propTl,
          // markers: true,
        })
      })

      mm.add(bp.tabUp, () => {
        // Test Cards

        const testLo$ = sel('.test__lo')
        if (isDeskSafari || !testLo$) return
        const testItem$a = selAll('.test__item')
        let testItemRight$a = []
        const testLoOffset = testLo$.offsetLeft
        testItem$a.forEach((el, i) => {
          const elOffset = el.offsetLeft
          // console.log(testLoOffset - elOffset)

          if (testLoOffset - elOffset < 0) {
            testItemRight$a.push(el)
          }
        })
        // gsap.set(testItemRight$a, { y: 100 })

        ScrollTrigger.create({
          trigger: testLo$,
          start: 'top bottom',
          endTrigger: testLo$,
          end: 'bottom top',
          scrub: true,
          animation: gsap.fromTo(testItemRight$a, { y: 100 }, { y: -100, ease: 'none' }),
        })
      })

      // Test
      // console.log('x')
      const epic$ = sel('.epic-props-sec')
      const testW$ = sel('.epic-test-sec-w')
      const test$ = sel('.epic-test-sec')
      const testC$ = sel('.epic-test__c')
      const testA$ = test$?.sel('.btn')
      const tableW$ = sel('.epic-table-sec-w')
      const table$ = sel('.epic-table-sec')
      gsap.set(test$, { marginTop: '-100vh' })
      // gsap.set(test$, { marginTop: '-100vh', marginBottom: '-100vh' })

      const testTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } })
      ScrollTrigger.create({
        trigger: epic$,
        start: 'bottom bottom',
        end: '+=100%',
        // end: '+=200%',
        scrub: true,
        pin: test$,
        // pinSpacing: false,
        // animation: testTl,
      })
      async function videoModal() {
        const videoBtn$ = sel('#customPlayerBtn')

        const sec$ = sel('.epic-test-sec')
        const _modW$ = sec$?.querySelector('.mod-w')
        if (!videoBtn$ || !_modW$) return console.log('no video btn')
        const modW$ = sel('body').appendChild(_modW$)

        const close$ = modW$.querySelector('.mod__x-w')
        const mod$ = modW$.querySelector('.mod')
        const bg$ = modW$.querySelector('.mod-bg')
        modW$.classList.add('display-hide')

        const _player = modW$.querySelector('.custom_player.is--test')
        // console.log(_player.getAttribute('src'))
        const src = _player.getAttribute('data-src') || 'youtube/4UgnVc7kRxE'
        const player = await VidstackPlayer.create({
          target: _player,
          src: src,
          // src: 'vimeo/1061484821',
          // poster:
          // 'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/6826898440714274aa9fd120_67575b133690ca3c5bb9254a_test_img1_q85-gigapixel-low%20resolution%20v2-4x%20copy.webp',
          crossOrigin: true,
          playsInline: true,
          viewType: 'video',
          load: 'idle',
          layout: new VidstackPlayerLayout(),
        })

        const tl = gsap
          .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
          .to(
            {},
            {
              onStart: () => {
                modW$.classList.remove('display-hide')
              },
              onReverseComplete: () => {
                modW$.classList.add('display-hide')
              },
              duration: 0.1,
            }
          )
          .to(modW$, { opacity: 1 })
          .from(mod$, { y: 50 }, 0)

        const closeModal = (e) => {
          e?.stopImmediatePropagation()
          tl.reverse()
          player.pause()
        }

        videoBtn$.onclick = (e) => {
          // console.log('pl', player.state.canPlay)
          tl.play()

          if (player.state.canPlay) {
            player.play()
          } else {
            player.addEventListener(
              'can-play',
              (event) => {
                // console.log('canplay')
                player.play()
              },
              { once: true }
            )
          }
        }
        ;[close$, bg$].forEach((el) => {
          el.onclick = closeModal
        })

        player.addEventListener('ended', (event) => {
          closeModal()
        })

        callAfterResize(() => closeModal())
        // console.log('videoBtn$', videoBtn$)
      }
      videoModal()
      mm.add(bp.tabUp, () => {
        // Footer

        const cta$ = sel('.epic-cta-sec')
        const ctaH$ = cta$.querySelector('h2')
        const ctaHsT$ = SplitText.create(ctaH$, { type: 'words, chars' })
        const ctaP$ = cta$.querySelector('.epic-cta__info>div:not(.button-group)')
        const ctaBtn$ = cta$.querySelector('.btn')
        const ctaBgSvg$ = cta$.querySelector('.epic-cta__bg-w.is--svg')
        const ctaBgWebp$ = cta$.querySelector('.epic-cta__bg-w-w.is--webp')
        const footer$ = sel('.footer')
        // console.log(ctaBgSvg$, ctaBgWebp$)
        if (isDeskSafari) {
          ctaBgSvg$.style.display = 'none'
          ctaBgWebp$.style.display = 'block'
        }
        const ctaTl = gsap
          .timeline({ defaults: { ease: 'power3.out', duration: 1 } })
          //
          .from(
            ctaHsT$.chars,
            {
              autoAlpha: 0,
              // filter: 'blur(50px)',
              ...ifChromeBlur,
              stagger: 0.03,
              ease: 'none',
            },
            0
          )
          .from(ctaP$, { autoAlpha: 0, y: -20 }, '<50%')
          .from(ctaBtn$, { autoAlpha: 0, y: -20 }, '<10%')
          .from(footer$, { y: 20, autoAlpha: 0, duration: 3 }, '<10%')

        ScrollTrigger.create({
          trigger: cta$,
          start: 'top 80%',
          // end: '+=100%',
          // scrub: true,
          animation: ctaTl,
          toggleActions: 'play none none reverse',
        })
      })
    })
    // stResizeObserver()
  })
}
